export const I18N_COMMON_CONTEXT = 'common';
export const TERMS_AND_CONDITIONS = 'terms-and-conditions';
export const PRIVACY_POLICY = 'privacy-policy';
export const ABOUT_US = 'about-us';
